import React from "react";

import SearchPropertyCard from "../../enhancers/SearchPropertyCard";
import SearchPropertyPopup from "../../enhancers/SearchPropertyPopup";

import SearchBar from "./sections/search-bar";
import SearchView from "@coninsa-site/project/src/pages/search-view/search-view";
import Container from "@coninsa-s2/container";
import Heading from "@coninsa-s2/heading";
import { RentFrequentSearch } from "../../sections/frequent-search/controller/RentFrequentSearch";

import searchRentalHousingConfigs from "../../facets/search-rental-housing";

interface SearcRentalPageProps {
  navigate: (string) => void;
}

export const SearcRentalPage: React.FC<SearcRentalPageProps> = ({
  navigate = (url) => console.log(url),
}) => {
  return (
    <div>
      <SearchView
        navigate={navigate}
        searchBar={SearchBar}
        itemCard={SearchPropertyCard}
        popupCard={SearchPropertyPopup}
        configs={searchRentalHousingConfigs}
      />

      <div>
        <Container>
          <Heading
            as="h2"
            tint="teal"
            size="4xl"
            condensed
            className="lg:mt-16 lg-10"
          >
            Búsquedas <span className="is-highlighted">frecuentes</span>
          </Heading>
        </Container>
        <RentFrequentSearch />
      </div>
    </div>
  );
};

export default SearcRentalPage;
